import { render } from "./StatefulIcon.vue?vue&type=template&id=b9b5feee&scoped=true"
import script from "./StatefulIcon.vue?vue&type=script&lang=js"
export * from "./StatefulIcon.vue?vue&type=script&lang=js"

import "./StatefulIcon.vue?vue&type=style&index=0&id=b9b5feee&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b9b5feee"

export default script